import React, { useCallback, useContext, useMemo } from 'react'

import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { connect } from 'react-redux'

import useQuota from '../../../../utils/api/hooks/useQuota'
import { QuotaFormModalContext, Types } from '../../../../Providers/Forms/QuotaForm/QuotaFormModalProvider'
import { Action, ActionTypes, GlobalDeleteAction } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import ActionsRow from '../../../../Components/antd/Lists/ActionsRow'
import { firstOrDefault, isNonEmptyArray } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../../reducers/UserReducer'
import { ColorsPalette } from '../../../../config/colors'

const mapStateToProps = state => ({ user: selectUser(state), t: selectTranslate(state) })

const QuotaToolBar = ({ selectedQuotas = [], onChange, onUnselect, user, t }) => {
  const { setFormHandler } = useContext(QuotaFormModalContext)

  const quotaHandler = useQuota({ callback: onChange })

  const handleEditClick = useCallback(() => {
    setFormHandler(handler => ({ ...handler, data: firstOrDefault(selectedQuotas), callback: quotaHandler.update, type: Types.QUOTA }))
  }, [selectedQuotas, setFormHandler, quotaHandler.update])

  const actions = useMemo(() => [
    new Action({
      title: t('quota_table_menu.buttons.edit_quota'),
      className: () => 'mr-4',
      ghost: true,
      icon: faEdit,
      type: ActionTypes.GLOBAL,
      color: selectedQuotas.length === 1 ? ColorsPalette.BLUE_ICON : ColorsPalette.LIGHT_GREY,
      disabled: selectedQuotas.length !== 1,
      onClick: handleEditClick
    }),
    new GlobalDeleteAction({
      title: t('quota_table_menu.buttons.delete_quota'),
      disabled: !isNonEmptyArray(selectedQuotas),
      ghost: true,
      onDelete: () => quotaHandler.delete(selectedQuotas)
    })
  ], [selectedQuotas, handleEditClick, quotaHandler.delete])

  return (
    <div className='z-500'>
      <ActionsRow
        actions={actions}
        buttonTitle={t('quota_toolbar.button_title', { numberOfQuotas: selectedQuotas.length })}
        buttonTooltipTitle={t('quota_toolbar.button_tooltip_title')}
        data={selectedQuotas}
        onUnselect={onUnselect}
      />
    </div>
  )
}

export default connect(mapStateToProps)(QuotaToolBar)
